<script setup>
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import {
  KkButton,
} from '../../../../components/base'
const route = useRoute()
const { t } = useI18n()
const { company_uuid } = route.params

</script>

<template>
  <div>
    <h2 class="c-pageTitle">
      {{ $t('pages.CompaniesStoreSnsPost.index.requiredSnsConnection.title') }}
    </h2>
    <p>{{ $t('pages.CompaniesStoreSnsPost.index.requiredSnsConnection.notice') }}</p>
    <div class="c-button c-button--left">
      <KkButton
        :to="{ name: 'CompaniesSnsOauth', params: { company_uuid: company_uuid } }"
        :text="t('pages.CompaniesStoreSnsPost.index.requiredSnsConnection.doConnect')"
      />
    </div>
  </div>
</template>
